var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("div", { class: _vm.$store.state.loadEvents ? " wait" : "" }, [
        _vm.$store.state.loadEvents
          ? _c(
              "div",
              {
                staticClass:
                  "text-center justify-content-center align-items-center",
              },
              [_vm._m(0)]
            )
          : _vm._e(),
      ]),
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "fade" } },
        [_c("router-view")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "spinner-border align-items-center",
        staticStyle: { width: "4rem", height: "4rem" },
        attrs: { role: "status" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }